import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import Icon from '../../../components/AppIcon';

const PROGRAMMES = [
  {
    icon: 'GraduationCap',
    title: 'Responsible gaming education',
    description:
      'Free workshops and plain-language guides on safe play. Over 25,000 players have taken the session so far.',
    color: '#25D366',
  },
  {
    icon: 'Wifi',
    title: 'Digital literacy programme',
    description:
      'Teaching rural communities how digital payments and online safety actually work, run with partner NGOs.',
    color: '#5B8CFF',
  },
  {
    icon: 'Trophy',
    title: 'Youth sports sponsorship',
    description:
      'Kit, coaching and tournament slots for local cricket and kabaddi teams across several states.',
    color: '#F0C24B',
  },
  {
    icon: 'PiggyBank',
    title: 'Financial literacy workshops',
    description:
      'Budgeting, savings and risk basics — the same bankroll discipline we teach players, taught to communities.',
    color: '#B98CFF',
  },
];

const PARTNERS = [
  { name: 'Akshaya Patra Foundation', description: 'Mid-day meal programmes for children', contribution: '₹50 Lakhs donated' },
  { name: 'Teach for India', description: 'Education programmes in rural and urban communities', contribution: '₹25 Lakhs donated' },
  { name: 'Digital India Foundation', description: 'Digital literacy and technology adoption', contribution: '₹30 Lakhs donated' },
];

const TOOLS = [
  { title: 'Time limits', description: 'Daily, weekly or monthly caps on session time', icon: 'Timer' },
  { title: 'Spending controls', description: 'Deposit and loss limits that hold, no exceptions', icon: 'Wallet' },
  { title: 'Self-exclusion', description: 'Take a break — we lock the account until you return', icon: 'PauseCircle' },
  { title: 'Support helpline', description: '24/7 counselling support for gaming-related concerns', icon: 'LifeBuoy' },
  { title: 'Educational resources', description: 'Straight guides on playing responsibly and spotting tilt', icon: 'BookOpen' },
];

const CommunityImpactSection = ({ onWhatsAppClick }) => (
  <section className="relative overflow-hidden py-24">
    <span className="aurora left-[-8%] bottom-[10%] h-96 w-96 bg-wa-green/20" aria-hidden="true" />

    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <span className="badge-pill"><Icon name="HeartHandshake" size={13} /> Community &amp; responsibility</span>
        <h2 className="mt-6 font-heading text-display font-bold text-white">
          A platform is only as good as the <span className="gold-text">community</span> it feeds
        </h2>
        <p className="mt-4 text-body-lg text-white/60">
          Part of every rupee we earn goes back out — into education, sport and the tools that keep gaming a game.
        </p>
      </div>

      <div className="perspective mt-14 grid gap-6 sm:grid-cols-2">
        {PROGRAMMES.map((p, i) => (
          <article key={p.title} className="card-3d animate-rise p-7" style={{ animationDelay: `${i * 70}ms` }}>
            <span
              className="mb-5 flex h-13 w-13 items-center justify-center rounded-2xl p-3.5"
              style={{ background: `${p.color}1F` }}
            >
              <Icon name={p.icon} size={24} color={p.color} />
            </span>
            <h3 className="font-heading text-lg font-bold text-white">{p.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-white/55">{p.description}</p>
          </article>
        ))}
      </div>

      {/* Partners */}
      <div className="card-flat mt-8 p-8">
        <h3 className="text-center font-heading text-xl font-bold text-white">Where the giving goes</h3>
        <div className="mt-7 grid gap-5 md:grid-cols-3">
          {PARTNERS.map((p) => (
            <div key={p.name} className="rounded-2xl border border-white/8 bg-white/[0.04] p-5 text-center">
              <span className="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-victory-red/12">
                <Icon name="Heart" size={19} color="#FF3D71" />
              </span>
              <div className="font-display text-sm font-semibold text-white">{p.name}</div>
              <div className="mt-1 text-xs text-white/45">{p.description}</div>
              <div className="mt-3 inline-block rounded-full bg-wa-green/12 px-3 py-1 text-[0.68rem] font-semibold text-wa-green">
                {p.contribution}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Responsible gaming tools */}
      <div className="panel-gold mt-8 p-8">
        <div className="text-center">
          <h3 className="font-heading text-xl font-bold text-white">Play responsibly — we will help you do it</h3>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-white/55">
            Ask the desk for any of these and it is switched on the same day. No arguments, no retention scripts.
          </p>
        </div>

        <div className="mt-7 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {TOOLS.map((t) => (
            <div key={t.title} className="flex items-start gap-3 rounded-2xl border border-white/8 bg-white/[0.04] p-4">
              <Icon name={t.icon} size={18} color="#F0C24B" className="mt-0.5 shrink-0" />
              <div>
                <div className="font-display text-sm font-semibold text-white">{t.title}</div>
                <div className="mt-0.5 text-xs text-white/50">{t.description}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <button onClick={onWhatsAppClick} className="btn-3d btn-3d-wa">
            <FaWhatsapp size={19} /> Set my limits on WhatsApp
          </button>
          <p className="mt-3 text-xs text-white/40">18+ only · gaming involves financial risk · play within your means</p>
        </div>
      </div>
    </div>
  </section>
);

export default CommunityImpactSection;
